const leftPanel = require('../../stores/views/stores-left-panel.view.html').trim(),
    centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    let rootScopeListener;

    $stateProvider
        .state('shop.stores', {
            resolve: {
                google: [
                    'GoogleMapService', function (googleMapService) {
                        return googleMapService.loadMap();
                    },
                ],
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('stores');
                    },
                ],
            },
            views: {
                'content@root': {
                    template: `${leftPanel} ${centerPanel} ${rightPanel}`,
                },
            },
        })
        .state('shop.locator', {
            parent: 'shop.stores',
            url: '/storelocator',
            onEnter: [
                '$rootScope', '$state', 'StoreService', function ($rootScope, $state, storeService) {
                    // this is a hack becaues onEnter doesn't fire if you move from
                    // a child state to a parent state. Therefore we need to listen for all state changes
                    // and unselect a store if we are arriving in this state.
                    rootScopeListener = $rootScope.$on('$stateChangeSuccess', () => {
                        if ($state.is('shop.locator')) {
                            storeService.setSelectedStore(undefined);
                        }
                    });
                },
            ],
            onExit: [
                function () {
                    rootScopeListener();
                },
            ],
            views: {
                'left-panel': {
                    controller: [
                        'BreakpointsService', 'StoreFilterService', function (breakpointsService, storeFilterService) {
                            this.storeFilterService = storeFilterService;

                            this.showLeftPanel = function () {
                                return breakpointsService.isSmallFormat();
                            };
                        },
                    ],
                    controllerAs: 'storeLocatorLeftCtrl',
                    template: `
                        <wow-store-locator-search
                            divisions="storeLocatorLeftCtrl.storeFilterService.divisions"
                            facilities="storeLocatorLeftCtrl.storeFilterService.facilities">
                        </wow-store-locator-search>
                    `,
                },
                'center-panel': {
                    template: '<wow-store-locator-map></wow-store-locator-map>',
                },
            },
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Stores' });
                    },
                ],
            },
        })
        .state('shop.locator.store', {
            url: '/:store',
            params: {
                storeDetails: null,
            },
            onEnter: [
                'StoreService', '$state', '$stateParams', function (storeService, $state, $stateParams) {
                    const storeInfo = storeService.getStoreInfoFromUrlParams($stateParams.store);

                    if ($stateParams.storeDetails && storeService.urlParametersValid($stateParams.storeDetails, storeInfo)) {
                        storeService.setSelectedStore($stateParams.storeDetails);
                    } else if (storeInfo && storeInfo.storeNo) {
                        storeService.getStore(storeInfo.storeNo, storeInfo.division)
                            .then((store) => {
                                if (storeService.urlParametersValid(store, storeInfo)) {
                                    storeService.setSelectedStore(store);
                                } else {
                                    $state.go('error.404', null, { location: 'replace' });
                                }
                            });
                    } else {
                        $state.go('error.404', null, { location: 'replace' });
                    }
                },
            ],
        })
        .state('shop.tripplanner', {
            parent: 'shop.stores',
            url: '/tripplanner?{destination}',
            views: {
                'left-panel': {
                    controller: [
                        'StoreFilterService', 'TripPlannerService', '$stateParams', function (storeFilterService, tripPlannerService, $stateParams) {
                            this.storeFilterService = storeFilterService;
                            this.tripPlannerService = tripPlannerService;
                            this.$stateParams = $stateParams;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-trip-planner-search
                            divisions="$ctrl.storeFilterService.divisions"
                            facilities="$ctrl.storeFilterService.facilities"
                            destination="$ctrl.$stateParams.destination">
                        </wow-trip-planner-search>
                    `,
                },
                'center-panel': {
                    controller: ['TripPlannerService', function (tripPlannerService) {
                        this.tripPlannerService = tripPlannerService;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-trip-planner-map
                            directions="$ctrl.tripPlannerService.directions"
                            route-index="$ctrl.tripPlannerService.routeIndex"
                            waypoint-stores="$ctrl.tripPlannerService.waypointStores"
                            stores="$ctrl.tripPlannerService.stores"
                            selected-store="$ctrl.tripPlannerService.selectedStore">
                        </wow-trip-planner-map>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/stores.js